import * as React from 'react';

const Success = () => <h1>Success!</h1>;

export default Success;
